<template>
  <div class="section std gallery">
    <div class="section-container">
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <ns_card_2 />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ns_card_2 from "./ns-prodotti-card-2";

export default {
  name: "ns-prodotti-2",
  components: {
    ns_card_2,
  },

  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  margin: 100px 0;
  padding-bottom: 0;
}
.section-container {
  height: 100vh;
}
.container {
  font-size: 1em;
  @media (min-width: 1921px){
    font-size: var(--font-size-large);
  }
  height: calc(100vh - 80px);
  background-color: #26262a;
  width: 100%;
  max-width: 100%!important;
  padding: 0;
  h2 {
    color: #fff;
  }
  > .row {
    width: 90%;
    max-width: 90%;
  }
}
@media (max-width: 576px){
  .container, .content, .section-container, .section.std {
    height: 100%!important;
  }
  .section {
    padding: 25px 0;
    .section-container {
      margin: 0;
      max-width: 100%;
    }
  }
  .container {
    padding: 0;
    .row {
      padding:0;
      .col-md-12 {
        padding: 0;
      }
    }
  }
}
@media (min-width: 1921px ){
  .container {
    //font-size: 1.5em;
  }
}
</style>
